export default function SimpleInput({
  value,
  label,
  onChange,
  onBlur,
  disabled,
  placeholder = "0.00",
  type = "text",
}) {
  return (
    <div className="floating-input-wrapper">
      <input
        type={type}
        value={value ?? ""}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={(e) => {
          e.target.select(); // Select full value on click/focus
        }}
      />
      {label && <label>{label}</label>}
    </div>
  );
}
